import type React from "react";
import { useEffect, useState } from "react";

import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { HealthReportV2Response } from "api/types/GetHealthReportsV2Response";
import { MUICheckBox } from "shared/atoms/inputs";

import { ReportsDropdownV2 } from "../ReportsDropdown/ReportsDropdownV2";

interface Props {
  reportList: HealthReportV2Response[];
  selected: number[];
  changeCallback: (selectedIds: number[]) => void;
  rowsCallback: (hide: boolean) => void;
}

export const HealthReportsHeaderV2: React.FC<Props> = ({ reportList, selected, changeCallback, rowsCallback }) => {
  const { t } = useTranslation();
  const [hideRows, setHideRows] = useState(false);

  useEffect(() => {
    if (selected.length < 2 && hideRows) {
      setHideRows(false);
      rowsCallback(false);
    }
  }, [selected.length, hideRows, rowsCallback]);

  const handleCheck = () => {
    setHideRows(prev => {
      rowsCallback(!prev);
      return !prev;
    });
  };

  return (
    <Stack direction="row" alignItems="center" flexWrap="wrap" gap={2} mb={2}>
      <Box sx={{ width: 300, position: "relative", zIndex: 102 }}>
        <ReportsDropdownV2 reportList={reportList} selected={selected} changeCallback={changeCallback} />
      </Box>
      <MUICheckBox
        name="only-changes-v2"
        label={t("patients.health_reports.changed_rows")}
        checked={hideRows}
        disabled={selected.length < 2}
        onChange={handleCheck}
        unregistered
      />
    </Stack>
  );
};
